import type { GTMEcommerceReturnType, GTMItemData, GTMItemsReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMViewItemEcommerceReturnType {
    item_list_id: string;
    item_list_name: string;
    items: GTMItemsReturnType[];
}

interface GTMSelectItemReturnType extends GTMEcommerceReturnType<GTMViewItemEcommerceReturnType> {}

interface GTMSelectItemModelData extends GTMItemData {
    index: number;
    listId: string;
    listName: string;
}

export default class GTMSelectItemModel extends GTMBaseModel {
    public static parseToGTMData({
        index,
        listId,
        listName,
        id,
        title,
        country,
        region,
        department,
        place,
        discount,
        pricePerNight,
        instantBooking,
        quantity = 1
    }: GTMSelectItemModelData): GTMSelectItemReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'select_item',
            ecommerce: {
                item_list_id: listId,
                item_list_name: listName,
                items: [
                    {
                        index,
                        item_id: id,
                        item_name: title,
                        item_category: country,
                        item_category2: region,
                        item_category3: department,
                        item_category4: place,
                        discount,
                        quantity,
                        instant_booking: instantBooking,
                        price: pricePerNight
                    }
                ]
            }
        };
    }
}
